import { mascotMoves } from './move-catalog'
import type { MascotMove } from './move-catalog'
import type { Frame, MotionPose } from './move-types'
import { poseChannels } from './move-types'

export function samplePose(frames: readonly Frame[], progress: number, out: MotionPose) {
  let index = 0
  while (index < frames.length - 2 && progress > frames[index + 1].at) {
    index++
  }
  const a = frames[index]
  const b = frames[index + 1]
  const previous = frames[Math.max(0, index - 1)]
  const next = frames[Math.min(frames.length - 1, index + 2)]
  const span = b.at - a.at
  const t = Math.max(0, Math.min(1, (progress - a.at) / span))
  for (const channel of poseChannels) {
    const incoming =
      index === 0 ? 0 : ((b[channel] - previous[channel]) / (b.at - previous.at)) * span
    const outgoing =
      index + 1 === frames.length - 1 ? 0 : ((next[channel] - a[channel]) / (next.at - a.at)) * span
    out[channel] =
      (2 * t * t * t - 3 * t * t + 1) * a[channel] +
      (t * t * t - 2 * t * t + t) * incoming +
      (-2 * t * t * t + 3 * t * t) * b[channel] +
      (t * t * t - t * t) * outgoing
  }
}

export function sampleMove(move: MascotMove, progress: number, out: MotionPose) {
  samplePose(mascotMoves[move].frames, progress, out)
}
